import { useState } from 'react';

import { LegalDisclaimer } from '@playbooks/components/auth/legal-disclaimer';
import { RegisterFields } from '@playbooks/components/auth/register-fields';
import { GithubAuthBtn } from '@playbooks/components/github/github-auth-btn';
import { GoogleAuthBtn } from '@playbooks/components/google/google-auth-btn';
import { Button } from '@playbooks/ui/components/button';
import { DialogFooter, DialogHeader, DialogTitle } from '@playbooks/ui/components/dialog';
import { Icon } from '@playbooks/ui/components/icon';
import { Separator } from '@playbooks/ui/components/separator';

import { useStore } from 'contexts';
import { useAction } from 'hooks';

const ReferralFlowRegister = ({ model, referralCode, onClose, onView, onNext }) => {
	const [user, setUser] = useState<any>({});
	const store = useStore();

	// Actions
	const [onSave, saveTask] = useAction(async () => {
		const response = await store.createRecord({ url: '/auth/register', params: { referralCode }, data: user });
		await onNext(response.data);
	});

	const onSubmit = e => {
		e.preventDefault();
		onSave();
	};

	// Render
	return (
		<form onSubmit={onSubmit}>
			<DialogHeader>
				<DialogTitle className='gap-4 flex-start'>
					<Button variant='outline' size='xs' onClick={() => onView('welcome')}>
						<Icon data-icon='inline-start' type='far' icon='chevron-left' aria-hidden />
					</Button>
					<span>Create your account</span>
				</DialogTitle>
			</DialogHeader>
			<div>
				<RegisterFields user={user} setUser={setUser} />
			</div>
			<DialogFooter className='block space-y-4'>
				<Button type='submit' size='default' isLoading={saveTask.running} className='w-full'>
					Create account
				</Button>
				<div className='flex-middle gap-3 text-xs text-foreground-subtle'>
					<Separator />
					<span className='shrink-0'>or continue with</span>
					<Separator />
				</div>
				<div className='grid grid-cols-2 gap-2'>
					<GoogleAuthBtn variant='outline' size='default' referralCode={referralCode} onNext={onNext}>
						Google
					</GoogleAuthBtn>
					<GithubAuthBtn variant='outline' size='default' referralCode={referralCode} onNext={onNext}>
						GitHub
					</GithubAuthBtn>
				</div>
				<LegalDisclaimer />
			</DialogFooter>
		</form>
	);
};

export { ReferralFlowRegister };
